module.exports = __webpack_public_path__ + "img/ht_icon_user.8632103c.svg";